import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { forkJoin, Observable } from 'rxjs';

import { frequencia } from '../../../../../../../../../models/frequencia.interface';
import { toPost } from '../../../../../../../../../models/rest.interface';
import { ButtonComponent } from '../../../../../../../../../shared/button/button.component';
import { RolesDirective } from '../../../../../../../../../shared/directive/directive-roles.directive';
import { InputIconComponent } from '../../../../../../../../../shared/input-icon/input-icon.component';
import { LoaderService } from '../../../../../../../../../shared/loader/loader.service';
import { ModalComponent } from '../../../../../../../../../shared/modal/modal.component';
import { ModalService } from '../../../../../../../../../shared/modal/modal.service';
import { OptionSelect, SelectComponent } from '../../../../../../../../../shared/select/select.component';
import { UserService } from '../../../../../../../../../shared/services/user/user.service';
import { ToastService } from '../../../../../../../../../shared/toast/toast.service';
import { ToggleComponent } from '../../../../../../../../../shared/toggle/toggle.component';
import { AlunosService } from '../../../../../../alunos/alunos.service';
import { TurmasService } from '../../../../../turmas.service';
import { AusenciaJustificadaComponent } from './ausencia-justificada/ausencia-justificada.component';


@Component({
  selector: 'app-realizar-chamada',
  standalone: true,
  imports: [
    ModalComponent,
    ButtonComponent,
    InputIconComponent,
    SelectComponent,
    RolesDirective,
    ToggleComponent,
  ],
  templateUrl: './realizar-chamada.component.html',
  styleUrl: './realizar-chamada.component.scss',
})
export class RealizarChamadaComponent implements OnInit {
  // Esse componente terá a logica de mostrar as duas colunas da tabela no html conforme a quantidade de aulas
  alunos: any[] = [];
  idUser!: number;
  form = new FormGroup({
    turmas: new FormControl<number>(0, Validators.required),
    materias: new FormControl<number>(0, Validators.required),
    presente: new FormControl<boolean>(true, Validators.required),
    justificativa: new FormControl(''),
    users: new FormControl<number>(0, Validators.required),
    alunos: new FormControl<number>(0, Validators.required),
    data: new FormControl('', Validators.required),
    grade_curriculars: new FormControl<number | null>(
      null,
      Validators.required,
    ),
  });
  mostrarActions: boolean = false;
  idTurma!: number;
  idMateria!: number;
  camposObrigatorios: boolean = false;
  optionsConteudos: OptionSelect[] = [];
  segunda_aula: boolean = false;
  toggle = new FormControl('');
  constructor(
    private readonly modalService: ModalService,
    private readonly turmaService: TurmasService,
    private readonly alunosService: AlunosService,
    private readonly userService: UserService,
    private readonly toast: ToastService,
    private readonly loaderService: LoaderService,
  ) {
    this.turmaService.infos_chamada.subscribe((value) => {
      if (value.materiaId != null && value.turmaId) {
        this.idMateria = value.materiaId;
        this.idTurma = value.turmaId;
      }
    });
    this.idUser = this.userService.user.id;
  }
  ngOnInit(): void {
    this.form.controls.turmas.setValue(this.idTurma);
    this.form.controls.materias.setValue(this.idMateria);
    this.form.controls.users.setValue(this.idUser);
    this.form.controls.turmas.setValue(this.idTurma);
    this.form.controls.data.setValue(this.getTodayFormatted());
    // this.listenConteudos();
    this.buscarAlunosTurma();
    this.montarSelectConteudo();
  }

  get turma(): any {
    return this.turmaService.getTurma
  }

  getTodayFormatted(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
    // const today = new Date();
    // return today.toLocaleString('pt-BR', {
    //   day: '2-digit',
    //   month: '2-digit',
    //   year: 'numeric',
    //   hour: '2-digit',
    //   minute: '2-digit',
    //   hour12: false
    // });
  }

  getYearMonthDay(dateString: string): string {
    const date = new Date(dateString);

    const year = date.getUTCFullYear(); // Pega o ano em UTC
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Pega o mês em UTC (mês começa do 0, então somamos 1)
    const day = String(date.getUTCDate()).padStart(2, '0'); // Pega o dia do mês em UTC

    return `${year}-${month}-${day}`; // Retorna a data no formato YYYY-MM-DD
  }

  finalizarChamada() {
    const todosPresenteAula1 = this.alunos.every(
      (aluno) => aluno.status['aula 1'] === true,
    );

    if (!todosPresenteAula1) {
      this.toast.notify({
        message: 'Preencha a chamada corretamente (Aula 1)',
        type: 'INFO',
      });
      return;
    }

    let todosPresenteAula2 = true;
    if (this.segunda_aula) {
      todosPresenteAula2 = this.alunos.every(
        (aluno) => aluno.status['aula 2'] === true,
      );

      if (!todosPresenteAula2) {
        this.toast.notify({
          message: 'Preencha a chamada corretamente (Aula 2)',
          type: 'INFO',
        });
        return;
      }
    }

    // Criando um array de Observables
    const chamadas$ = this.alunos.flatMap((aluno) => {
      const chamadas = [this.salvarChamada(aluno.id, aluno.presente['aula 1'])];

      if (this.segunda_aula) {
        chamadas.push(this.salvarChamada(aluno.id, aluno.presente['aula 2']));
      }

      return chamadas;
    });

    // Espera todas as chamadas finalizarem antes de fechar o modal
    forkJoin(chamadas$).subscribe({
      next: () => {
        this.modalService.close(true);
      },
      error: () => {
        this.toast.notify({ message: 'Erro ao salvar chamada', type: 'ERROR' });
      },
    });
  }

  changeConteudo(event: any) {
    this.form.controls.grade_curriculars.setValue(event);
  }

  fechar() {
    this.modalService.close(false);
  }

  formarChamada(idAluno: number, presenca: boolean, aula: string) {
    this.alunos.map((value) => {
      if (idAluno === value.id) {
        value.status[aula] = true; // Marcando que a chamada foi feita
        value.presente[aula] = presenca; // Definindo se foi presente ou ausente
      }
    });
  }

  editarChamada(idAluno: number, aula: string) {
    this.alunos.map((value) => {
      if (idAluno === value.id) {
        value.status[aula] = false;
      }
    });
  }

  salvarChamada(idAluno: number, presenca: boolean): Observable<any> {
    this.form.controls.alunos.setValue(idAluno);
    this.form.controls.presente.setValue(presenca);

    if (this.form.valid) {
      return this.loaderService.executeWithLoader(
        this.turmaService.salvarChamada(toPost(this.form.value as any)),
      );
    } else {
      this.toast.notify({
        message: 'Preencha os campos obrigatórios',
        type: 'INFO',
      });
      this.camposObrigatorios = true;
      return new Observable((observer) => observer.complete()); // Retorna um observable vazio
    }
  }

  getDateAtual(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Meses começam de 0, então somamos 1
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  montarSelectConteudo() {
    this.loaderService
      .executeWithLoader(
        this.turmaService.buscarFrequenciasPorMateriaTurmaEscola(
          this.idMateria,
          this.idTurma,
          {
            page: 1,
            pageSize: 99999999,
          }
        )
      )
      .subscribe({
        next: (frequencia: any) => {
          this.loaderService
            .executeWithLoader(
              this.turmaService.buscarGradeCurricularPorMateriaETurma(
                this.idMateria,
                this.idTurma
              )
            )
            .subscribe({
              next: (grade: any) => {
                if (grade.data.length === 0) {
                  this.toast.notify({
                    message: 'Não encontramos nenhum conteúdo cadastrado!',
                    type: 'WARNING',
                  });
                  this.modalService.close(false);
                }

                // // Variável para armazenar grades sem frequências na data de hoje
                // const gradesSemFrequenciaHoje: any[] = [];

                // grade.data.forEach((_grade: any) => {
                //   let temFrequenciaHoje = false;

                //   frequencia.data.forEach((_frequencia: any) => {
                //     // Verificar se a data da frequência é a data de hoje e se a grade currícular é a mesma
                //     if (
                //       _frequencia.grade_curriculars?.length > 0 && // Verifica se grade_curriculars existe e tem itens
                //       this.getDateAtual() === this.getYearMonthDay(_frequencia.data) &&
                //       _frequencia.grade_curriculars[0].id === _grade.id
                //     ) {
                //       temFrequenciaHoje = true;
                //     }
                //   });

                //   // Se não encontrou nenhuma frequência na data de hoje para essa grade, adiciona ao array
                //   if (!temFrequenciaHoje) {
                //     gradesSemFrequenciaHoje.push(_grade);
                //   }
                // });

                // montar combo
                this.optionsConteudos = grade.data.map((opt: any) => {
                  return { label: opt.titulo, value: opt.id };
                });
              },
            });
        },
      });
  }



  buscarAlunosTurma() {
    this.loaderService
      .executeWithLoader(this.alunosService.buscarAlunosPorTurma(this.idTurma))
      .subscribe({
        next: (alunos: any) => {
          this.alunos = alunos.data.map((aluno: any) => ({
            nome: aluno.nome,
            documentId: aluno.documentId,
            id: aluno.id,
            status: {},
            // Criando um Map para armazenar a presença por aula
            presente: {},
          }));
          this.mostrarActions = true;
        },
        error: () => {
          this.toast.notify({ message: 'Erro interno !', type: 'ERROR' });
        },
      });
  }

  aulaDupla(event: any) {
    this.segunda_aula = event;
    if (!event) {
      this.alunos.map((value) => {
        value.status['aula 2'] = false; // Marcando que a chamada foi feita
        value.presente['aula 2'] = false; // Definindo se foi presente ou ausente
      });
    }
  }

  ausenciaJustificada() {
    this.modalService.open(AusenciaJustificadaComponent);
  }
}
export interface aluno_frequencia {
  nome: string;
  documentId: string;
  id: number;
  status: { [aula: string]: boolean };
  presente: { [aula: string]: boolean };
}
